import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';
import { isNodeSearchFormEmpty } from 'src/components/Common/UI/SydFilter/SydFilterTypeChecker';


const convertToDataTable = (data: IGetNode[]): IGetNode[] => {
  const dataTableData: IGetNode[] = [];

  if(!data) return dataTableData;

  data.map(d => {
    dataTableData.push(d)
  })

  return dataTableData;
}

const mapFilterData = (data: INodeSearchForm | undefined): INodeSearchPost | {} => {
  if (isNodeSearchFormEmpty(data) || data == undefined) { return {} };
  return data;
}

const getAllNodes = async ( {data} : {data: INodeSearchForm | undefined}): Promise<IGetNode[]> => {
  const filterData = mapFilterData(data);
  const response =  await axiosDefaultApi.post(`api/Nodes/SearchNodes`, filterData);
  return convertToDataTable(response as unknown as IGetNode[]);
};

type QueryFnType = typeof getAllNodes;

type UseGetAllNodesOptions = {
  data: INodeSearchForm | undefined;
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllNodes = ({ data, config }: UseGetAllNodesOptions ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllNodes'],
    queryFn: () => getAllNodes({data}),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των κόμβων.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};